import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export const mutationCreateDokkioLabelTags = gql`
  mutation createDokkioLabelTags (
    $dokkioLabelTagNames: [String!]!
    $dokkioLabelRowCreateMethod: RowCreateMethod
    $dokkioTagRowCreateMethod: RowCreateMethod
  ) {
    createDokkioLabelTags (
      dokkioLabelTagNames: $dokkioLabelTagNames
      dokkioLabelRowCreateMethod: $dokkioLabelRowCreateMethod
      dokkioTagRowCreateMethod: $dokkioTagRowCreateMethod
    ) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
export default mutationCreateDokkioLabelTags;
